import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const COMPONENT_CLASS = "reports-sub-menu";

type ReportsSubMenuProps = {
    menuRef?: React.RefObject<HTMLDivElement>;
    style?: React.CSSProperties;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
};

export const ReportsSubMenu: React.FC<ReportsSubMenuProps> = ({
    menuRef,
    style,
    onMouseEnter,
    onMouseLeave,
}) => {
    const { t } = useTranslation();
    return (
        <div
            className={`${COMPONENT_CLASS} sub-menu`}
            ref={menuRef}
            style={style}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <div className="item-container">
                <Link
                    className='item report-sub-menu-item'
                    to="/reports/detail">
                    {t('reportType.detail')}
                </Link>

                <Link
                    className='item report-sub-menu-item'
                    to="/reports/score">
                    {t('reportType.score')}
                </Link>

                <Link
                    className='item report-sub-menu-item'
                    to="/reports/movement">
                    {t('reportType.movementHealth')}
                </Link>

                <Link
                    className='item report-sub-menu-item'
                    to="/reports/compliance">
                    {t('reportType.compliance')}
                </Link>

                <Link
                    className='item report-sub-menu-item'
                    to="/reports/wellness-summary">
                    {t('reportType.wellnessSummary')}
                </Link>

                <Link
                    className='item report-sub-menu-item'
                    to="/reports/summary">
                    {t('reportType.assessmentSummary')}
                </Link>

            </div>
        </div>

    );
}